"use strict";

module.exports = function contains(root, n) {
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/.3.4.1@rc-util/lib/Dom/contains.js
 ** module id = 505
 ** module chunks = 0 1
 **/